import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { toggleCaseManagerTermsAndConditons, resetCaseManagersStatus } from '../../reducers/case-managers-slice.js';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { msalInstance } from '../../index';
import Alert from 'react-bootstrap/Alert';
import { useNavigate } from 'react-router-dom';
import IcoArrowRight from '../../assets/ico-arrow-right.svg';
import ServiceAgreementHtml from '../service-agreement.js';


const TermsAndConditionsModal = ({ handleCloseModal, showModal, setTermsAndConditionsAccepted }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { status } = useSelector(state => state.caseManagers);

    // this is used to keep track of the number of times the user clicks decline
    const [numDeclined, setNumDeclined] = useState(0);

    // used to show the alert if the user declines the first time
    const [showAlert, setShowAlert] = useState(false);

    const handleAcceptTerms = () => {
        dispatch(toggleCaseManagerTermsAndConditons());
    };

    const handleDeclineTerms = () => {
        if (numDeclined < 2) {
            setShowAlert(true);
            setNumDeclined(numDeclined + 1);
        } else {
            // navigate to the homescreen and logout
            //let activeAccount = msalInstance.getActiveAccount();
            //if (activeAccount) {
            //    msalInstance.logoutRedirect(activeAccount);    
            //    navigate("/");
            //}             
            navigate("/portal");
        }
    };

    useEffect(() => {
        if (status === 'succeeded') {
            setTermsAndConditionsAccepted(true);
            dispatch(resetCaseManagersStatus()); 
            handleCloseModal(true); 
        } 
    }, [status])     

    return (
        <Modal
            backdrop="static"
            show={showModal}
            onHide={handleCloseModal}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Service Agreement</Modal.Title>
            </Modal.Header>
            <Alert show={showAlert} variant="warning" style={{ margin: '1rem' }}>
                <p>This Service Agreement must be accepted prior to using the Glucroft Investigations Application.</p>
                <hr />
                <div className="d-flex justify-content-end">
                    <Button onClick={() => setShowAlert(false)} variant="outline-warning">
                        Close me
                    </Button>
                </div>
            </Alert>

            <Modal.Body className="no-padding">
                <div className="form-field-wrapper">
                    <ServiceAgreementHtml />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="form-footer" style={{ width: '100%' }}>
                    <div className="form-footer-right">
                        <button type="submit" className="button tertiary" onClick={handleDeclineTerms}>
                            Decline 
                        </button>
                    </div>
                    <div className="form-footer-left"> 
                        <button type="submit" className="button tertiary" onClick={handleAcceptTerms}  >
                            Accept 
                        </button>
                    </div>
                </div>
            </Modal.Footer> 
        </Modal>

    )
};

export default TermsAndConditionsModal;
